function revealOnScroll(classNames, threshold = 0.25, stagger = 0) {
	if (!Array.isArray(classNames)) classNames = [classNames];

	classNames.forEach(className => {
		const elements = document.querySelectorAll(`.${className}`);

		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach((entry, index) => {
				if (entry.isIntersecting) {
					const delay = stagger * index;

					setTimeout(() => {
						entry.target.classList.add("opacity-100", "translate-y-0");
						entry.target.classList.remove("opacity-0", "translate-y-8");
					}, delay);

					obs.unobserve(entry.target);
				}
			});
		}, { threshold });

		elements.forEach(el => observer.observe(el));
	});
}

function revealHero() {
	const heroImage = document.querySelector(".reveal-hero-image");
	const heroTitle = document.querySelector(".hero-title");
	const heroButtons = document.querySelectorAll(".hero-button");

	const elements = [heroImage, heroTitle, ...heroButtons];

	if (!heroImage && !heroTitle) return;

	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				// Stagger timings: image -> title -> buttons
				let delay = 0;

				if (heroImage) {
					setTimeout(() => {
						heroImage.classList.add("opacity-100", "scale-100");
						heroImage.classList.remove("opacity-0", "scale-95");
					}, delay);
					delay += 1250;
				}

				if (heroTitle) {
					setTimeout(() => {
						heroTitle.classList.add("opacity-100", "translate-y-0", "scale-100");
						heroTitle.classList.remove("opacity-0", "translate-y-4", "scale-95");
					}, delay);
					delay += 2400;
				}

				heroButtons.forEach((btn, i) => {
					setTimeout(() => {
						btn.classList.add("opacity-100", "translate-y-0");
						btn.classList.remove("opacity-0", "translate-y-4");
					}, delay + i * 1000); // stagger between buttons
				});

				obs.unobserve(entry.target);
			}
		});
	}, { threshold: 0.25 });

	elements.forEach(el => {
		if (el) observer.observe(el);
	});
}

// Call it
revealHero();


function revealImages(className = "reveal-image", threshold = 0.25) {
	const images = document.querySelectorAll(`.${className}`);

	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add("opacity-100", "scale-100");
				entry.target.classList.remove("opacity-0", "scale-95");
				obs.unobserve(entry.target);
			}
		});
	}, { threshold });

	images.forEach(img => observer.observe(img));
}

revealImages();

revealHero();

// Reveal all cards at once
revealOnScroll(["vision", "services-offered", "cu-card", "info-card", "demo-form", "claim-form"], 0.25, 0);

// Reveal info-card with staggered time 
revealOnScroll(["info-grid-item"], 0.25, 250);
revealOnScroll(["achievements", "ks-way"], 0.25, 500);